import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nProvider";

export function LegalPage({ pageKey, testId }) {
  const { t, dict } = useI18n();
  const page = dict.pages[pageKey];

  useEffect(() => {
    document.title = `${page.title} — Zantravika`;
  }, [page.title]);

  return (
    <main className="relative pt-32 pb-24 lg:pt-40 lg:pb-32" data-testid={testId}>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className="flex items-center gap-3">
            <span className="h-px w-8 bg-emerald-500" />
            <p className="eyebrow">Zantravika · Legales</p>
          </div>
          <h1 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] text-balance">
            {page.title}
          </h1>
          <p className="mt-4 text-sm font-mono uppercase tracking-widest text-slate-400">{page.updated}</p>
          <p className="mt-8 text-base sm:text-lg text-slate-300 leading-relaxed">{page.intro}</p>
        </motion.div>

        <div className="mt-12 space-y-10">
          {page.sections.map((s, i) => (
            <motion.section
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            >
              <h2 className="font-display text-xl sm:text-2xl font-semibold text-white">{s.h}</h2>
              <p className="mt-3 text-base text-slate-300 leading-relaxed">{s.p}</p>
            </motion.section>
          ))}
        </div>
      </div>
    </main>
  );
}

export default LegalPage;
